export function getVideoPlaylistIsLoaded(state) {
    return state.videoPlaylist.isLoaded;
}

export function getVideoPlaylistUrl(state) {
    return state.videoPlaylist.url;
}

export function getVideoPlaylistId(state) {
    return state.videoPlaylist.id;
}

export function hasUploadedVideo(state) {
    return state.hasUploadedVideo
}